import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../api';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const token = searchParams.get('token') || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    try {
      await api.post('/api/auth/reset-password', { token, new_password: password });
      setMessage('Password reset successfully. Redirecting to login…');
      setTimeout(() => navigate('/account'), 2000);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Reset failed. The link may have expired.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Set new password</h2>
        {message ? (
          <p className="form-message">{message}</p>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <label>
              New Password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
              />
            </label>
            <label>
              Confirm Password
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </label>
            <button type="submit">Reset Password</button>
            {error && <p className="form-error">{error}</p>}
          </form>
        )}
      </div>
    </div>
  );
}
